/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Multica_Th5Inputs */

const en_mk_cmp_multica_th5 = /** @type {(inputs: Mk_Cmp_Multica_Th5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud pricing was not published when we checked.`)
};

const id_mk_cmp_multica_th5 = /** @type {(inputs: Mk_Cmp_Multica_Th5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga cloud tidak dipublikasikan saat kami periksa.`)
};

/**
* | output |
* | --- |
* | "Cloud pricing was not published when we checked." |
*
* @param {Mk_Cmp_Multica_Th5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_multica_th5 = /** @type {((inputs?: Mk_Cmp_Multica_Th5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Multica_Th5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_multica_th5(inputs)
	return en_mk_cmp_multica_th5(inputs)
});